import React, { useEffect } from 'react';
import { auth } from '../../services/firebase';
import { useCalendarEvents } from './useCalendarEvents';
import CalendarView from './CalendarView';
import EventsList from './EventsList';
import { styles } from './styles';

// Calendar Icon SVG
const CalendarIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const CalendarPage = () => {
  const {
    selectedDate,
    setSelectedDate,
    dayEvents,
    loading,
    dateStr,
    eventsByDate,
    latestMeetingDate
  } = useCalendarEvents();

  // Update last calendar visit timestamp when user opens this page
  useEffect(() => {
    const now = new Date().toISOString();
    // Make it user-specific
    const currentUser = auth.currentUser;
    if (currentUser) {
      localStorage.setItem(`lastCalendarVisit_${currentUser.uid}`, now);
    }
  }, []);

  const formattedDate = selectedDate.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerIcon}>
            <CalendarIcon />
          </div>
          <div>
            <h1 style={styles.title}>My Calendar</h1>
            <p style={styles.subtitle}>
              Manage your scheduled meetings and events
            </p>
          </div>
        </div>
        
        {/* Calendar Section */}
        <div style={styles.calendarSection}>
          <CalendarView 
            selectedDate={selectedDate}
            onDateSelect={setSelectedDate}
            eventsByDate={eventsByDate}
            latestMeetingDate={latestMeetingDate}
          />
        </div>
        
        {/* Events Section */}
        <div style={styles.eventsSection}>
          <h2 style={styles.eventsTitle}>
            Events for {formattedDate}
          </h2>
          <EventsList 
            events={dayEvents}
            loading={loading}
            dateStr={dateStr}
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;